import React from "react";

import { Clock3, Share2, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const BENEFITS = [
  {
    key: "secure",
    icon: ShieldCheck,
    tileClass: "bg-emerald-50 text-emerald-600 ring-emerald-100",
  },
  {
    key: "share",
    icon: Share2,
    tileClass: "bg-cfTableHeaderBackgroundColor text-cfPrimary ring-indigo-100",
  },
  {
    key: "access",
    icon: Clock3,
    tileClass: "bg-orange-50 text-orange-500 ring-orange-100",
  },
];

const BenefitsList = () => {
  const { t } = useTranslation(["walletOffer"]);

  return (
    <ul className="m-0 grid list-none grid-cols-1 gap-y-4 p-0 sm:grid-cols-3 sm:divide-x sm:divide-gray-100">
      {BENEFITS.map(({ key, icon: Icon, tileClass }) => (
        <li
          key={key}
          className="flex items-start gap-3 sm:px-[1rem] sm:first:pl-0 sm:last:pr-0"
        >
          <span
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ring-1 ${tileClass}`}
            aria-hidden="true"
          >
            <Icon className="h-5 w-5" strokeWidth={2} />
          </span>
          <span className="min-w-0">
            <span className="block text-sm font-semibold text-cfHeadingText">
              {t(`walletOffer:benefit_${key}_title`)}
            </span>
            <span className="mt-0.5 block text-xs leading-relaxed text-gray-500">
              {t(`walletOffer:benefit_${key}_description`)}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
};

export default BenefitsList;
